import React from 'react';
import 'Css/nuovo_dispositivo.css';

class NuovoDispositivo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      serialNumber: '',
      accessCode: ''
    };
  }

  onChangeSerialNumber = (e) => {
    this.setState({ serialNumber: e.target.value });
  }

  onChangeAccessCode = (e) => {
    this.setState({ accessCode: e.target.value });
  }

  onConfirm = () => {
    const { serialNumber, accessCode } = this.state;

    // Add your submit logic here
    console.log("Serial Number:", serialNumber);
    console.log("Access Code:", accessCode);

    this.props.onlineRegistration({ serialNumber: serialNumber, accessCode: accessCode });
  }

  render() {
    return (
      <div id="new-device" style={{ maxWidth: 400, margin: 'auto', padding: 20 }}>
        <h2>Register New Device</h2>

        <div style={{ marginBottom: 16 }}>
          <label htmlFor="serial-number" style={{ display: 'block', marginBottom: 4 }}>Serial Number</label>
          <input
            type="text"
            id="serial-number"
            value={this.state.serialNumber}
            onChange={this.onChangeSerialNumber}
            placeholder="Enter Serial Number"
            style={{ width: '100%', padding: 8 }}
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <label htmlFor="access-code" style={{ display: 'block', marginBottom: 4 }}>Access Code</label>
          <input
            type="text"
            id="access-code"
            value={this.state.accessCode}
            onChange={this.onChangeAccessCode}
            placeholder="Enter Access Code"
            style={{ width: '100%', padding: 8 }}
          />
        </div>

        {this.props.registerLoading ? (
          <div className="loader-container">
            <div className="spinner"></div>
            <span style={{ marginLeft: 10 }}>Registering...</span>
          </div>
        ) : (
          <button
            onClick={this.onConfirm}
            className="confirm-style"
            disabled={!this.state.serialNumber || !this.state.accessCode}
          >
            Confirm
          </button>
        )}
      </div>
    );
  }
}

export default NuovoDispositivo;
export { NuovoDispositivo };
